<div [class.hidden]="!show">
    <div class="loader-overlay">
        <div class="page-loading">
            <img class="loading-icon" width=106px; height=98px;
                src="../../../../../assets/media/loader/loader_bnspur_blue.svg">
        </div>
    </div>
</div>